import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import Terms from "@/apollo/datasources/terms";
import Uid2 from "@/apollo/datasources/uid2";
import config from "@/lib/config";
import Cookies from "@/lib/cookies";
import dayjs from "@/lib/day";
import debugLog from "@/lib/debugLog";
/**
 * Uid2Tokenの取得、管理を行うクラス
 *
 * @param {object} req - リクエスト
 * @param {object} res - レスポンス
 * @constructor
 */

var Uid2Token = /*#__PURE__*/function () {
  function Uid2Token(req, res) {
    _classCallCheck(this, Uid2Token);

    this.req = req;
    this.res = res;
    this.uid2 = new Uid2({
      req: req,
      res: res
    }); // this.uid2.initialize({ context: { req, res } });

    this.terms = new Terms({
      req: req,
      res: res
    }); // this.terms.initialize({ context: { req, res } });

    this.cookies = new Cookies(req, res);
  }
  /**
   * getToken.
   *
   * uid2トークンの取得
   *
   * @return {Promise<string>} advertising_token
   */


  _createClass(Uid2Token, [{
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _data$uid;

        var agree, data, now, refreshFrom, refreshTokenExpires, _refreshData$uid, refreshData, _generateData$uid, generateData, _generateData$uid2, _generateData;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.req.userToken) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", null);

              case 2:
                if (!this.req.adultMode) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", null);

              case 4:
                _context.next = 6;
                return this.isAdTermsAgree();

              case 6:
                agree = _context.sent;

                if (agree) {
                  _context.next = 11;
                  break;
                }

                debugLog("[uid2] ad terms not agree.");
                this.delete();
                return _context.abrupt("return", null);

              case 11:
                data = this.getData();
                debugLog("[uid2] from cookie", data);

                if (!(data !== null && data !== void 0 && (_data$uid = data.uid2) !== null && _data$uid !== void 0 && _data$uid.advertising_token)) {
                  _context.next = 37;
                  break;
                }

                // AdvertisingTokenを更新すべきかを確認
                now = dayjs();
                refreshFrom = dayjs(data.uid2.refresh_from);
                refreshTokenExpires = dayjs(data.uid2.refresh_expires);
                debugLog("[uid2] refreshFrom: ".concat(refreshFrom.format(), ", refreshTokenExpires: ").concat(refreshTokenExpires.format()));

                if (!now.isBefore(refreshFrom)) {
                  _context.next = 23;
                  break;
                }

                debugLog("[uid2] now is before refreshFrom");
                return _context.abrupt("return", data.uid2.advertising_token);

              case 23:
                if (!now.isBefore(refreshTokenExpires)) {
                  _context.next = 31;
                  break;
                }

                debugLog("[uid2] now is before refreshTokenExpires"); // refresh

                _context.next = 27;
                return this.refresh();

              case 27:
                refreshData = _context.sent;
                return _context.abrupt("return", refreshData === null || refreshData === void 0 ? void 0 : (_refreshData$uid = refreshData.uid2) === null || _refreshData$uid === void 0 ? void 0 : _refreshData$uid.advertising_token);

              case 31:
                _context.next = 33;
                return this.generate();

              case 33:
                generateData = _context.sent;
                return _context.abrupt("return", generateData === null || generateData === void 0 ? void 0 : (_generateData$uid = generateData.uid2) === null || _generateData$uid === void 0 ? void 0 : _generateData$uid.advertising_token);

              case 35:
                _context.next = 41;
                break;

              case 37:
                _context.next = 39;
                return this.generate();

              case 39:
                _generateData = _context.sent;
                return _context.abrupt("return", _generateData === null || _generateData === void 0 ? void 0 : (_generateData$uid2 = _generateData.uid2) === null || _generateData$uid2 === void 0 ? void 0 : _generateData$uid2.advertising_token);

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getToken() {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
    /**
     * getData.
     *
     * Cookieに保存されているuid2トークンのデータを取得
     *
     * @return {Object}
     */

  }, {
    key: "getData",
    value: function getData() {
      var value = this.cookies.get(config.uid2tokenCookieName);

      if (value) {
        return JSON.parse(Buffer.from(value, "base64").toString());
      } else {
        return null;
      }
    }
    /**
     * setData.
     *
     * APIで取得したuid2トークンのデータをcookieに保存
     *
     * @param {object} data
     */

  }, {
    key: "setData",
    value: function setData(data) {
      this.cookies.set({
        name: config.uid2tokenCookieName,
        value: Buffer.from(JSON.stringify(data)).toString("base64")
      });
    }
    /**
     * generate.
     *
     * UID2トークンの生成
     *
     * @return {Promise<Uid2Result|null>} data
     */

  }, {
    key: "generate",
    value: function () {
      var _generate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.uid2.generate();

              case 2:
                data = _context2.sent;
                debugLog("[uid2] generate token", data);

                if (!(data && (data === null || data === void 0 ? void 0 : data.status) === Uid2.STATUS_SUCCESS)) {
                  _context2.next = 7;
                  break;
                }

                this.setData({
                  email_hash: data.email_hash,
                  uid2: data.uid2
                });
                return _context2.abrupt("return", data);

              case 7:
                return _context2.abrupt("return", null);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function generate() {
        return _generate.apply(this, arguments);
      }

      return generate;
    }()
    /**
     * refresh.
     *
     * UID2トークンのリフレッシュ
     *
     * @return {Promise<Uid2Result|null>} data
     */

  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var tokenValue, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tokenValue = this.getData();

                if (!tokenValue) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 4;
                return this.uid2.refresh(tokenValue.uid2.refresh_token, tokenValue.uid2.refresh_response_key, tokenValue.email_hash);

              case 4:
                data = _context3.sent;
                debugLog("[uid2] refresh token", data);

                if (!(data && (data === null || data === void 0 ? void 0 : data.status) === Uid2.STATUS_SUCCESS)) {
                  _context3.next = 9;
                  break;
                }

                this.setData({
                  email_hash: data.email_hash,
                  uid2: data.uid2
                });
                return _context3.abrupt("return", data);

              case 9:
                return _context3.abrupt("return", null);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
    /**
     * delete.
     *
     * uid2トークン情報の削除
     */

  }, {
    key: "delete",
    value: function _delete() {
      this.cookies.remove([config.uid2tokenCookieName, config.adTermsConfirmCookie.name]);
    }
    /**
     * isAdTermsAgree.
     *
     * 広告規約に同意しているかどうか
     *
     * @return {Promise<boolean>} result
     */

  }, {
    key: "isAdTermsAgree",
    value: function () {
      var _isAdTermsAgree = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var cookieName, confirmed, termsData, parsedJson;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                cookieName = config.adTermsConfirmCookie.name;
                confirmed = this.cookies.get(cookieName);

                if (confirmed) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 5;
                return this.terms.getTerm(config.terms.advertisingTerm, true);

              case 5:
                termsData = _context4.sent;
                return _context4.abrupt("return", this.adTermsAgreeCache(termsData));

              case 9:
                parsedJson = JSON.parse(confirmed);
                return _context4.abrupt("return", parsedJson === null || parsedJson === void 0 ? void 0 : parsedJson.result);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function isAdTermsAgree() {
        return _isAdTermsAgree.apply(this, arguments);
      }

      return isAdTermsAgree;
    }()
  }, {
    key: "adTermsAgreeCache",
    value: function adTermsAgreeCache(termsData) {
      var _rev$agreement;

      var _config$adTermsConfir = config.adTermsConfirmCookie,
          cookieName = _config$adTermsConfir.name,
          maxAge = _config$adTermsConfir.maxAge;
      var rev = termsData.current_revision;
      debugLog("[uid2] ad terms agree? ".concat(JSON.stringify(rev)));
      var result = (rev === null || rev === void 0 ? void 0 : rev.number) === (rev === null || rev === void 0 ? void 0 : (_rev$agreement = rev.agreement) === null || _rev$agreement === void 0 ? void 0 : _rev$agreement.term_revision_number);
      this.cookies.set({
        name: cookieName,
        value: JSON.stringify({
          result: result
        }),
        options: {
          maxAge: maxAge
        }
      });
      return result;
    }
  }, {
    key: "clearAdTermsAgreeCache",
    value: function clearAdTermsAgreeCache() {
      this.cookies.remove(config.adTermsConfirmCookie.name);
    }
  }]);

  return Uid2Token;
}();

export default Uid2Token;